import { formNames } from '@wkda/carlead-creation-form';
export function getFieldSubmissionErrors(fieldErrors, errorMessages) {
  if (!fieldErrors || !fieldErrors.length) {
    return {};
  }
  return fieldErrors.reduce((errors, fieldError) => {
    if (fieldError.field === 'carLead.email' && fieldError.message) {
      errors[formNames.email] = errorMessages[formNames.email] || errorMessages.globalUnknownError;
    }
    return errors;
  }, {});
}